import React from "react";

export const useCurrentRef = <T,>(value: T) => {
  const ref = React.useRef(value);
  ref.current = value;
  return ref;
};
